import { useDispatch } from 'react-redux';
import { Button } from '@simplywallst/ui-core';
import PlusSolidIcon from '@simplywallst/ui-core/icons/PlusSolid';
import { Heading } from '@simplywallst/ui-core/next';
import { useCreateTransactionPortfolio } from '@/hooks/portfolio/useCreateTransactionPortfolio';
import { ROUTE_PORTFOLIO_TRANSACTIONS_CREATE } from '@/constants/routes';

export const NewTransactionPortfolio = () => {
  const dispatch = useDispatch();
  const { mutate, status } = useCreateTransactionPortfolio({
    onSuccess: ({ createTransactionPortfolio }) => {
      const { id } = createTransactionPortfolio;
      dispatch({
        type: ROUTE_PORTFOLIO_TRANSACTIONS_CREATE,
        payload: { portfolioId: id },
      });
    },
  });
  return (
    <div
      className="grid gap-x2 sm:gap-x3 content-between"
      data-cy-id="portfolio-legacy-creation"
    >
      <div className="grid gap-x1_25">
        <Heading as="h2">Want to track every transaction?</Heading>
        <div className="text-xs text-softer text-pretty max-w-[45ch]">
          Use our transaction portfolio.
        </div>
      </div>
      <Button
        styleType="louderLarge"
        alignIcon="left"
        className="w-fit focus-visible:ring-2 focus-visible:duration-0 focus-visible:ring-accent"
        onClick={() => {
          mutate({ name: 'Transactions' });
        }}
        isLoading={status === 'pending'}
        disabled={status === 'pending'}
      >
        Transaction portfolio
        <PlusSolidIcon />
      </Button>
    </div>
  );
};
